export const MOVIES_LOADING = 'MOVIES_LOADING';
export const MOVIES_ACTIVE = 'MOVIES_ACTIVE';
export const MOVIES_STEPS = 'MOVIES_STEPS';
export const MOVIES_ANIMATION = 'MOVIES_ANIMATION';
export const MOVIES_NEXT_RELEASES_LOADING = 'MOVIES_NEXT_RELEASES_LOADING';
export const MOVIES_NEXT_RELEASES = 'MOVIES_NEXT_RELEASES';
